<template>
  <div>
    <OrganizationFields :v="v" />
    <MrpaTrustee
      :v="v.trustee"
      label="Сведения о представителе юридического лица"
    />
  </div>
</template>

<script>
import OrganizationFields, {
  organizationFieldsModel,
  organizationFieldsValidation,
} from '@/components/services/ExtractionRod/Applicant/OrganizationFields';
import MrpaTrustee, {
  mrpaTrusteeModel,
  getMrpaTrusteeValidation,
} from '@/components/services/elements/MrpaTrustee';
import cloneDeep from 'clone-deep';

export const machineOrganizationModel = {
  ...organizationFieldsModel,
  trustee: cloneDeep(mrpaTrusteeModel),
};

export const getMachineOrganizationValidation = (organization) => ({
  ...organizationFieldsValidation,
  trustee: getMrpaTrusteeValidation(organization.trustee),
});

export default {
  name: 'Organization',
  props: {
    v: {
      type: Object,
      required: true,
    },
  },
  components: {
    OrganizationFields,
    MrpaTrustee,
  },
};
</script>
